var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2678 21.2322C24.2915 20.2559 22.7085 20.2559 21.7322 21.2322C20.7559 22.2085 20.7559 23.7915 21.7322 24.7678L29.9645 33L21.7322 41.2322C20.7559 42.2085 20.7559 43.7915 21.7322 44.7678C22.7085 45.7441 24.2915 45.7441 25.2678 44.7678L33.5 36.5355L41.7322 44.7678C42.7085 45.7441 44.2915 45.7441 45.2678 44.7678C46.2441 43.7915 46.2441 42.2085 45.2678 41.2322L37.0355 33L45.2678 24.7678C46.2441 23.7915 46.2441 22.2085 45.2678 21.2322C44.2915 20.2559 42.7085 20.2559 41.7322 21.2322L33.5 29.4645L25.2678 21.2322Z",
    fill: "#C70000",
    stroke: "#C70000",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 5.90909C18.3142 5.90909 6.40909 17.8142 6.40909 32.5C6.40909 47.1858 18.3142 59.0909 33 59.0909C47.6858 59.0909 59.5909 47.1858 59.5909 32.5C59.5909 17.8142 47.6858 5.90909 33 5.90909ZM0.5 32.5C0.5 14.5507 15.0507 0 33 0C50.9493 0 65.5 14.5507 65.5 32.5C65.5 50.4493 50.9493 65 33 65C15.0507 65 0.5 50.4493 0.5 32.5Z",
    fill: "#C70000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.24cdf1df6a2df1daff97118325f37b39.svg";
export { ForwardRef as ReactComponent };